import React, { forwardRef } from 'react';

import { CurlContent, CurlWrapper } from './CurlStyles';
import { FlexDiv, GenericP } from 'commonStyles';
import { curlStyles, CONTENT_TYPE, CURL_THEME } from '../../config';
import { syntaxHighlight } from 'UtilityComponents/intergarationUtils';

import CopyData from '../../../../common/copyData/copyData';

const Curl = ({ data = {}, type, forwardedRef }) => {
	const { curlHead, styles = {}, curl = {}, isCopy = true } = data;

	const { theme = CURL_THEME.DARK } = styles;
	const curlTheme = curlStyles[theme];

	const printjson = () => {
		let printData = '';
		try {
			printData = curl;
			if (type === CONTENT_TYPE.JSON ) {
				printData = JSON.stringify(curl, undefined, 2);
			}
			printData = syntaxHighlight(printData);
		} catch (e) {

		}

		return (
			<CurlWrapper
				defaultColor={curlTheme.defaultColor} colorKey={curlTheme.contentKey} colorValue={curlTheme.contentValue} dangerouslySetInnerHTML={{ __html: printData }}
			/>
		);
	};

	const copyStyles = {
		...styles.copy
	};

	return (
		<FlexDiv bdr={`1px solid ${curlTheme.bdrColor}`} $direction='column' bdrRad='8px' overflow='hidden' top_M='16'>
			<FlexDiv $bg={curlTheme.headingBg} position='relative'>
				{curlHead &&
				<GenericP
					flex='1'
					top_P='10'
					bottom_P='10'
					left_P='10'
					right_P='10'
					color={curlTheme.heading} line_height='20px'
					dangerouslySetInnerHTML={{ __html: curlHead }}
				/>}

				{isCopy && <CopyData wrapper={forwardedRef} colorTheme={curlTheme} copyStyles={copyStyles} styles={styles} />}

			</FlexDiv>
			<CurlContent
				justify='flex-start'
				top_P='12'
				bottom_P='12'
				left_P='16'
				right_P='16'
				$direction='column'
				ref={forwardedRef}
				color={curlTheme.contentBg}>
				{printjson(curl, 0)}
			</CurlContent>
		</FlexDiv>
	);
};

export default forwardRef((props, ref) => <Curl {...props} forwardedRef={ref} />);
